import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'util/currency';

const formatWithCurrency = value =>
  value > 0 ? formatCurrency(value, 'USD', 2) : '$0';

export const useCustomerOverviewExtendedAttributes = (
  extendedAttributes: Record<string, string> = {},
) => {
  const { t } = useTranslation();
  const {
    BASKET_VALUE_TOTAL,
    NO_OF_TRANSACTIONS,
    LAST_365_DAYS_BASKET_TOTAL,
    AVERAGE_BASKET_VALUE,
    DAYS_SINCE_LAST_PURCHASE,
    PURCHASES_PER_MONTH,
  } = extendedAttributes;

  const visibleExtendedAttributes = [
    {
      label: t('page.customers.overview.lifeTimeSpend'),
      value: formatWithCurrency(BASKET_VALUE_TOTAL),
    },
    {
      label: t('page.customers.overview.lifeTimeOrders'),
      value: NO_OF_TRANSACTIONS ?? 0,
    },
    {
      label: t('page.customers.overview.last365DaysBasketTotal'),
      value: !!LAST_365_DAYS_BASKET_TOTAL
        ? formatWithCurrency(LAST_365_DAYS_BASKET_TOTAL)
        : undefined,
    },
    {
      label: t('page.customers.overview.averageBasketValue'),
      value: formatWithCurrency(AVERAGE_BASKET_VALUE),
    },
    {
      label: t('page.customers.overview.daysSinceLastPurchase'),
      value: DAYS_SINCE_LAST_PURCHASE ?? 0,
    },
    {
      label: t('page.customers.overview.averageOrdersPerMonth'),
      value: PURCHASES_PER_MONTH ?? 0,
    },
  ];

  const filteredVisibleExtendedAttributes = visibleExtendedAttributes.filter(
    ({ value }) => value !== undefined,
  );

  return filteredVisibleExtendedAttributes;
};
